// extracted by css-extract-rspack-plugin
export default {"diffEntryHeader":"AutomatedReviewDiffEntry-module__diffEntryHeader__hTou_","automatedReviewDiff":"AutomatedReviewDiffEntry-module__automatedReviewDiff__qZi0H"};